import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IArticle } from '../../../prisma-xs/models/article.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-configurator-catalog-badge',
    templateUrl: './configurator-catalog-badge.component.html',
    styleUrls: ['./configurator-catalog-badge.component.scss'],
    standalone: false
})
export class ConfiguratorCatalogBadgeComponent {
  @Input() article: IArticle;
  @Input() searchText: string;
}
